// export const API_KEY = 'AIzaSyDkHfzWGbioDcDFfUY7l-iMRASQu7GAoIw'
export const API_KEY = 'AIzaSyC1Jh1AAuryif37xiEC9dHkd4-C9vlmTVE'
